export function IsAccounting() {
    if (window.location.href.split("/").pop().toLowerCase() === "amministrazioneflussi")
        return true;
    else
        return false;
}